<template>
  <div class="content" v-loading="loading">
    <div class="yxxx-header-wrapper">
       <div class="yxxx-header-wrappers">
          <div class="yxxx-header-img">
            <img :src="info.collage_logo" alt="">
          </div>
          <div class="yxxx-header-content">
            <div class="content-header">
              <div class="name">{{info.collegeName || ""}}</div>
            </div>
            <div class="content-introduction" style="margin-top: 22px;">
              <div class="department" v-if="info.collegeAdmin">
                主管部门：<span class="content-introduction-item zgbmmc">{{info.collegeAdmin}}</span>
              </div>
              <div class="yxtx" v-if="info.is985 || info.is211 || info.two_yiliu || info.yanjiuY || info.isGuo=='国重点' || info.qiangji=='是'">
                院校特性：
                <span class="content-introduction-item zgbmmc" v-if="info.is985">985</span>
                <span class="content-introduction-item zgbmmc" v-if="info.is211">211</span>
                <span class="content-introduction-item zgbmmc" v-if="info.two_yiliu">双一流</span>
                <span class="content-introduction-item zgbmmc" v-if="info.yanjiuY">研究生院</span>
                <span class="content-introduction-item zgbmmc" v-if="info.isGuo=='国重点'">国重点</span>
                <span class="content-introduction-item zgbmmc" v-if="info.qiangji=='是'">强基</span>
              </div>
            </div>
            <div class="content-info">
              <div class="content-info-item" style="margin-top: 20px;display: flex;align-items: center;">
               <span v-if="info.collegeProvince">
                所在地：
                <span class="yxszd" style="margin-right: 20px;">{{info.collegeProvince}}</span>
               </span>
               <div class="content-info-items">
                {{info.collegeLevel}} | {{info.collegeNature}} | {{info.collegeType}}
              </div>
              </div>
              <div class="content-info-item asas" style="margin-top: 10px;">

              </div>
            </div>
          </div>
       </div>
    </div>

    <!--以下内容为会员才可以查看-->
    <div class="yxxx-content">
       <div class="yxxx-content-left">
         <!--院校简介-->
         <div class="leftTitlt">
           <div class="redLine1"></div>
           <div class="redLine2"></div>
           院校简介
         </div>
         <div class="greyBackgroundContainer">
           <div class="greyBackgroundText">
            <p v-html="info.college_info || info.collegeName || '--'"></p>
           </div>
           <div class="learnMoreContainer">
               <a :href="info.baidubai || info.gw_url" target="_blank" class="ab">了解更多>></a>
           </div>
         </div>
         <!--图标 建校 年限硕士-->
         <div class="iconContainer">
            <div class="iconItemContainer" v-if="info.jianxiao_time">
               <div class="icon">
                  <img src="../../assets/collegeTime.44ec30dd.png" alt="" class="img">
               </div>
               <div class="iconText">{{info.jianxiao_time}}年</div>
            </div>
            <div class="iconItemContainer" v-if="info.collegeCity">
               <div class="icon">
                  <img src="../../assets/collegeAddress.76eb74a1.png" alt="" class="img">
               </div>
               <div class="iconText">{{info.collegeCity}}</div>
            </div>
            <div class="iconItemContainer" v-if="info.shuoshiNum">
               <div class="icon">
                  <img src="../../assets/master.8625be4c.png" alt="" class="img">
               </div>
               <div class="iconText">
                 {{info.shuoshiNum}}
                <el-tooltip class="item" effect="dark" placement="bottom">
                  <div slot="content">指院校各类型硕士点数量，自左到右依次为：
                    <br/>一级学科/二级学科（含自主设置）/交叉学科（含自主设置）/专硕</div>
                    <i class="el-icon-question" style="margin-left: 5px;"></i>
                </el-tooltip>
                </div>
            </div>
            <div class="iconItemContainer" v-if="info.boshiNum">
               <div class="icon">
                  <img src="../../assets/doctor.c9a95ec4.png" alt="" class="img">
               </div>
               <div class="iconText">
                 {{info.boshiNum}}
                <el-tooltip class="item" effect="dark" placement="bottom">
                  <div slot="content">指院校各类型博士点数量，自左到右依次为：<br/>
一级学科/二级学科（含自主设置）/交叉学科（含自主设置）</div>
                    <i class="el-icon-question" style="margin-left: 5px;"></i>
                </el-tooltip>
                </div>
            </div>
            <div class="iconItemContainer" v-if="info.sex_score">
               <div class="icon">
                  <img src="../../assets/ren.png" alt="" class="img">
               </div>
               <div class="iconText">{{info.sex_score}}</div>
            </div>
            <div class="iconItemContainer" v-if="info.zhandi">
               <div class="icon">
                  <img src="../../assets/collegeAddress.76eb74a1.png" alt="" class="img">
               </div>
               <div class="iconText">{{info.zhandi}}亩</div>
            </div>
         </div>
         <!--师资力量-->
         <div class="leftTitlt">
           <div class="redLine1"></div>
           <div class="redLine2"></div>
           师资力量
         </div>
         <div class="greyBackgroundContainer" v-if="info.shizi_li">
           <div class="greyBackgroundText">
            <p v-html="info.shizi_li || '--'"></p>
           </div>
         </div>
                  <!--优势学科-->
                  <div class="leftTitlt" v-if="info.youshi">
           <div class="redLine1"></div>
           <div class="redLine2"></div>
           优势学科
         </div>
         <div class="greyBackgroundContainer" v-if="info.youshi">
           <div class="greyBackgroundText">
            <p v-html="info.youshi || '--'"></p>
           </div>
         </div>
         <!--硕博点介绍-->
         <div class="leftTitlt">
           <div class="redLine1"></div>
           <div class="redLine2"></div>
           硕博点介绍
         </div>
         <div class="greyBackgroundContainer" v-if="isCha!=0&& info.shuo_bo">
           <div class="greyBackgroundForm">
             <el-form label-width="110px">
               <el-form-item label="硕博点概况" v-if="info.shuo_bo">
                <p v-html="info.shuo_bo || '--'"></p>
               </el-form-item>
               <el-form-item label="博士一级学科" v-if="info.boshi_one">
                <p v-html="info.boshi_one || '--'"></p>
               </el-form-item>
               <el-form-item label="博士二级学科" v-if="info.boshi_er">
                <p v-html="info.boshi_er || '--'"></p>
               </el-form-item>
               <el-form-item label="博士交叉学科" v-if="info.boshi_two">
                <p v-html="info.boshi_two || '--'"></p>
               </el-form-item>
               <el-form-item label="硕士一级学科" v-if="info.shuoshi_one">
                <p v-html="info.shuoshi_one || '--'"></p>
               </el-form-item>
               <el-form-item class="aaa" v-if="info.shuoshi_er">
                 <div slot="label" style="line-height: 22px;">
                   硕士二级学科
                   <div>(含自主设置)</div>
                 </div>
                 <p v-html="info.shuoshi_er || '--'"></p>
               </el-form-item>
               <el-form-item class="aaa" v-if="info.shuoshi_jiaocha">
                 <div slot="label" style="line-height: 22px;">
                   硕士交叉学科
                   <div>(含自主设置)</div>
                 </div>
                  <p v-html="info.shuoshi_jiaocha || '--'"></p>
               </el-form-item>
               <el-form-item label="专硕" v-if="info.zhuan_shuo">
                  <p v-html="info.zhuan_shuo || '--'"></p>
               </el-form-item>
             </el-form>
           </div>
         </div>
                 <!--双一流建设学科-->
                 <div class="leftTitlt" v-if="info.two_yiliu">
           <div class="redLine1"></div>
           <div class="redLine2"></div>
           双一流建设学科
         </div>
         <div class="greyBackgroundContainer" v-if="info.two_yiliu">
           <div class="greyBackgroundText">
            <p v-html="info.tw0_jianshe || '--'"></p>
           </div>
         </div>
         <!--保研率详情-->
         <div class="leftTitlt" v-if="info.isBao==1  && (info.one_baoyan_lv || info.two_baoyan_lv || info.three_baoyan_lv)">
           <div class="redLine1"></div>
           <div class="redLine2"></div>
           保研率详情
         </div>
         <div class="greyBackgroundContainer"  v-if="userinfo && info.isBao==1  && (info.one_baoyan_lv || info.two_baoyan_lv || info.three_baoyan_lv)" style="padding-bottom: 40px;">
            <div class="mt2" v-if="info.one_baoyan_lv">{{info.dangnian}}年保研率：{{formatBaoyanLv(info.one_baoyan_lv)}}</div>
            <div class="mt2" v-if="info.two_baoyan_lv">{{info.qunian}}年保研率：{{formatBaoyanLv(info.two_baoyan_lv)}}</div>
            <div class="mt2" v-if="info.three_baoyan_lv">{{info.qiannian}}年保研率：{{formatBaoyanLv(info.three_baoyan_lv)}}</div>
         </div>
         <div class="greyBackgroundContainer"  v-if="!userinfo && info.isBao==1  && (info.one_baoyan_lv || info.two_baoyan_lv || info.three_baoyan_lv)" style="padding-bottom: 40px;">
            <div class="mt2" v-if="info.one_baoyan_lv">{{info.dangnian}}年保研率：{{formatBaoyanLv(info.one_baoyan_lv)}}</div>
            <div class="mt2" v-if="info.two_baoyan_lv">{{info.qunian}}年保研率：{{formatBaoyanLv(info.two_baoyan_lv)}}</div>
            <div class="mt2" v-if="info.three_baoyan_lv">{{info.qiannian}}年保研率：{{formatBaoyanLv(info.three_baoyan_lv)}}</div>
         </div>
         <!--第四轮学科评估-->
          <div class="leftTitlt" v-if="info.silun && info.silun.length>0 && info.silun.filter(r=>{return r.content;})>0">
            <div class="redLine1"></div>
            <div class="redLine2"></div>
            第四轮学科评估
          </div>
          <div class="greyBackgroundContainer" v-if="info.silun && info.silun.length>0 && info.silun.filter(r=>{return r.content;})>0">
            <el-table
                :header-cell-style="{'background': '#1CB278','color':'#fff'}"
                :data="info.silun.filter(r=>{return r.content;})"
                border sortable
                style="width: 100%">
                <el-table-column
                    prop="title"
                    label="评定结果"
                    width="160" align="center">
                  </el-table-column>
                 <el-table-column label="学科" align="center">
                    <template slot-scope="scope">
                       {{scope.row.content}}
                    </template>
                 </el-table-column>
           </el-table>
          </div>
                   <!--专业设置-->
         <div class="leftTitlt" v-if="info.tese_major || (info.major && info.major.length>0)">
           <div class="redLine1"></div>
           <div class="redLine2"></div>
           专业设置
         </div>
         <div class="greyBackgroundContainer"  v-if="info.tese_major" id="nationalCharacteristicMajors">
           <div class="nationalCharacteristicMajorsTitle">
              国家特色专业
           </div>
           <div id="nationalCharacteristicMajorsText" class="greyBackgroundText" style="line-height: 36px;">
            <p v-html="info.tese_major || '--'"></p>
           </div>
         </div>
         <div class="greyBackgroundContainer" v-if="info.major && info.major.length>0">
           <el-table
               :header-cell-style="{'background': '#1CB278','color':'#fff'}"
               :data="info.major"
               border sortable
               style="width: 100%">
               <el-table-column
                   prop="majors"
                   label="类别"
                   width="160" align="center">
                 </el-table-column>
                <el-table-column label="专业" align="center">
                   <template slot-scope="scope">
                      <span>{{scope.row.major}}</span>
                   </template>
                </el-table-column>
          </el-table>
         </div>
     <!--院校其他信息-->
         <div class="leftTitlt">
           <div class="redLine1"></div>
           <div class="redLine2"></div>
           院校其他信息
         </div>
         <div class="greyBackgroundContainer">
           <div class="greyBackgroundForm">
             <el-form label-width="110px">
               <el-form-item label="重点实验(实训)室" v-if="info.zhong_shiyan">
                  <p v-html="info.zhong_shiyan || '--'"></p>
               </el-form-item>
               <el-form-item label="转专业" v-if="info.zhuan_major">
                    <p v-html="info.zhuan_major || '--'"></p>
               </el-form-item>
               <el-form-item label="奖学金设置" v-if="info.xuejin_setting">
                  <p v-html="info.xuejin_setting || '--'"></p>
               </el-form-item>
               <el-form-item label="食宿条件" v-if="info.shisu">
                  <p v-html="info.shisu || '--'"></p>
               </el-form-item>
               <el-form-item label="知名校友" v-if="info.xiaoyou">
                  <p v-html="info.xiaoyou || '--'"></p>
               </el-form-item>
               <el-form-item label="校招企业" v-if="info.xiaozhao">
                  <p v-html="info.xiaozhao || '--'"></p>
               </el-form-item>
             </el-form>
           </div>
         </div>

       </div>
       <div class="yxxx-content-right">
         <!--实景VR-->
         <div class="rightTitle">实景VR</div>
         <div id="realisticVrContainer">
           <a :href="info.vr" target="_blank" style="width: 100%;height: 160px;">
             <img :src="info.shi_vr" alt="" class="img">
           </a>
         </div>
          <!--软科排名-->
          <div class="rightTitle" v-if="info.ruan_pai || info.xiaoyou_paiming">高校排行</div>
          <div style="width: 100%;" v-if="info.ruan_pai || info.xiaoyou_paiming">
            <el-table
                :data="returnPai()"
                border sortable
                style="width: 100%">
                <el-table-column
                    label="排行榜"
                     align="center">
                     <template slot-scope="scope">
                      {{scope.row.title}}
                     </template>
                </el-table-column>
                <el-table-column
                    label="院校排名"
                     align="center">
                     <template slot-scope="scope">
                      {{info[scope.row.name] || "--"}}
                     </template>
                </el-table-column>
            </el-table>
          </div>
         <div class="rightTitle" style="margin-top: 20px;" v-if="info.gw_url || info.phone">其他信息</div>
          <div style="width: 100%;background: #fff;" v-if="info.gw_url || info.phone">
              <div style="width: 92%;margin:0 auto;padding-top: 10px;padding-bottom: 10px;font-size: 16px;color: #515151;line-height: 40px;">
                <div>
                  <span v-if="info.gw_url">
                    官方网址：<a :href="info.gw_url" target="_black" style="color: #515151;">{{info.gw_url || "--"}}</a>
                  </span>
                </div>
                <div>
                  官方电话：{{info.phone || "--"}}
                </div>
                <div>
                  <span v-if="info.zhaosheng_url">
                    招生网址：<a :href="info.zhaosheng_url" target="_black" style="color: #515151;">{{info.zhaosheng_url || "--"}}</a>
                  </span>
                </div>
                <div>
                  <span v-if="info.zhaosheng">
                    招生简章：
                    <a :href="info.zhaosheng" target="_black" style="color: #1CB278;">点击查看</a>
                  </span>
                </div>
                <div>
                  <span v-if="info.email" style="color: #515151;">官方邮箱：{{info.email || "--"}}</span>
                </div>
                <div>
                  <span v-if="info.address_detail" style="color: #515151;">详细地址：{{info.address_detail || "--"}}</span>
                </div>
              </div>
          </div>
          <!--系统使用说明-->
          <div class="rightTitle" style="margin-top: 20px;">系统使用说明</div>
          <div style="width: 100%;background: #fff;">
              <div style="width: 92%;margin:0 auto;padding-top: 10px;padding-bottom: 10px;font-size: 16px;color: #515151;line-height: 30px;">
                <div>1. 本查询系统数据来源于教育部官网、阳光高考、各省教育考试院、各院校官网及招生就业网、软科官网、中国科教评价网、麦可思研究院等，数据仅供参考，具体数据请以学校官网或考试院最新公布为准。</div>
                <div>2. 本站数据未经授权严禁转载，违者将依法追究责任。</div>
                <div>3. 如对本系统或相关服务有任何疑问，可联系客服反馈于我们。</div>
              </div>
          </div>
          <div class="rightTitle" style="margin-top: 20px;">联系客服</div>
          <div style="width: 100%;background: #fff;">
              <div style="width: 92%;margin:0 auto;padding-top: 10px;padding-bottom: 10px;">
                <img :src="ercode" style="width: 100%;" alt="">
              </div>
          </div>
       </div>
    </div>
    <!--以下内容为会员才可以查看-->

  </div>
</template>

<script>
  import {mapGetters} from "vuex"
  import { getCollegeDetail,getCollegeDetails } from "@/api/gw/config.js"
  import { ContantUser_index } from "@/api/gw/zonghe.js"
  import { isOddOrEvenDay } from "@/utils/rules.js"
  export default {
    data(){
      return{
         collegiate_id:"",
         info:{},
         loading:false,
         paihang:[
          {title:"软科",name:"ruan_pai"},
          {title:"校友会排名",name:"xiaoyou_paiming"}
         ],
         ercode:"",
         levelArr:[
				   {id:"ajia",title:"A+",major:"ajia"},{id:"a_s",title:"A",major:"a_s"},{id:"a_jian",title:"A-",major:"a_jian"},
				   {id:"b_jia",title:"B+",major:"b_jia"},{id:"b_ma",title:"B",major:"b_ma"},{id:"b_jian",title:"B-",major:"b_jian"},
				   {id:"c_jia",title:"C+",major:"c_jia"},{id:"c_mas",title:"C",major:"c_mas"},{id:"c_jian",title:"C-",major:"c_jian"},
				 ],
         i:null,
         isCha:0,
      }
    },
    computed:{
      ...mapGetters(['isLogin',"userinfo"]),
    },
    watch:{
      userinfo(e){
        if(e){
          this.getCollegeDetail();
        }
      },
    },
    mounted(){
      this.i = this.$route.query.i || null;
      this.isCha = this.$route.query.isCha || 0
      if(this.$route.query && this.$route.query.n){
        this.collegiate_id = this.$route.query.n
        this.ContantUser_index();
        if(!this.i){
           this.$store.dispatch("getUserInfo").then(()=>{

           })
        }else{
          this.getCollegeDetail();
        }
      }else{
        this.$message.error("院校不存在");
        this.$router.push({
          path:"/School"
        })
      }
    },
    methods:{
      ContantUser_index(){
          let type = isOddOrEvenDay();
          ContantUser_index({
            page:1,
            limit:2,
            status:1,
            type:type
          }).then(res=>{
            if(res.data.data && res.data.data.length>0){
						this.ercode = res.data.data[0].ercode
					}
          })
      },
      returnPai(){
        if(this.info.ruan_pai && this.info.xiaoyou_paiming){
          return this.paihang;
        }
        if(this.info.ruan_pai && !this.info.xiaoyou_paiming){
          return [
            {
              title:"软科",name:"ruan_pai"
            }
          ]
        }
        if(!this.info.ruan_pai && this.info.xiaoyou_paiming){
          return [
          {title:"校友会排名",name:"xiaoyou_paiming"}
          ]
        }
        return [];
      },
      getCollegeDetail(){
        this.loading = true
        if(this.i==1){
          getCollegeDetails({
            collegiate_id:this.collegiate_id,
            isCha:this.isCha
          }).then(res=>{
            // if(res.data.silun && res.data.silun.length==0){
            //   let a = res.data.silun.filter((item) => {
            //     return item.content;
            //   });
            //   res.data["silun"] = a
            // }
            
            for (let key in res.data) {
              if (typeof res.data[key] === 'string') {
                res.data[key] = res.data[key].replaceAll('\\n', '<br>&nbsp&nbsp&nbsp&nbsp');
              }
            }
            this.info = res.data
          }).finally(()=>{
            this.loading = false
          })
        }else{
          getCollegeDetail({
            collegiate_id:this.collegiate_id,
            isCha:this.isCha
          }).then(res=>{
            // if(res.data.silun && res.data.silun.length==0){
            //   let a = res.data.silun.filter((item) => {
            //     return item.content;
            //   });
            //   res.data["silun"] = a
            // }
             for (let key in res.data) {
              if (typeof res.data[key] === 'string') {
                res.data[key] = res.data[key].replaceAll('\\n', '<br>&nbsp&nbsp&nbsp&nbsp');
              }
            }
            this.info = res.data
          }).finally(()=>{
            this.loading = false
          })
        }
      },
      // 格式化保研率显示
      formatBaoyanLv(value){
        if(!value && value !== 0) return '--';
        // 如果已经是字符串且包含%，直接返回
        if(typeof value === 'string' && value.includes('%')){
          return value;
        }
        // 转换为数字
        const numValue = parseFloat(value);
        if(isNaN(numValue)) return '--';
        // 如果值小于1，说明是小数格式（如0.155），需要乘以100
        if(numValue < 1){
          return (numValue * 100).toFixed(2) + '%';
        }
        // 否则已经是百分比格式（如15.5），直接添加%
        return numValue.toFixed(2) + '%';
      },
    }
  }
</script>

<style lang="scss" scoped>
@import './scss/detail.scss';
.custom-header{
  background: #1CB278!important;
}

p{
  line-height: 28px;
  margin: 2px 3px 0px 5px;
}
  .yxxx-content{
    width: 1250px;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-bottom: 32px;
    .yxxx-content-right{
          width: 372px;
          border-radius: 4px;
    }
    .yxxx-content-left{
      width: 788px;
          background: #fff;
          border-radius: 4px;
          padding: 6px 30px 29px;
    }
  }
  .as{
    background: url(../../assets/yxxx_header_wangzhi.svg) 0 no-repeat!important;
  }
  .asas{
    background: url(../../assets/yxxx_header_dianhua.svg) 0 no-repeat!important;
  }
  .content-info{
    padding-left: 3px;
    .content-info-item{
          padding-left: 23px;
          font-size: 16px;
          line-height: 22px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          background: url(../../assets/yxxx_header_dizhi.svg) 0 no-repeat;
          margin-bottom: 6px;
      }
  }
  .content-introduction{
    padding-left: 3px;
    margin: 11px 0 16px;
    font-size: 16px;
    display: flex;
    align-items: center;
    .department{
          margin-right: 36px;
    }
    .content-introduction-item{
          display: inline-block;
          height: 28px;
          line-height: 26px;
          border-radius: 16px;
          border: 1px solid #fff;
          padding: 0 13px;
    }
  }
  .attention{
    display: flex;
    align-items: center;
  }
  .yxxx-header-content{
      width: 526px;
      margin-right: 36px;
      flex: 1;
      color: #fff;
      .content-header{
        height: 36px;
        display: flex;
        align-items: flex-end;
        .name{
          font-size: 28px;
              margin-right: 16px;
              color: #fff;
              line-height: 1;
        }
      }
  }
  .yxxx-header-img{
      width: 166px;
      height: 166px;
      padding: 15px;
      border-radius: 8px;
      margin-right: 27px;
      background-color: #fff;
      img{
        width: 100%;
        height: 1005;
      }
  }
.yxxx-header-wrapper{
  width: 100%;
  height: 246px;
  background: url(../../assets/yuanxiaoku.jpg) no-repeat 50%,linear-gradient(180deg,#49c48d,#1cb278);
  background-size: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .yxxx-header-wrappers{
    width: 1250px;
    height: 166px;
    margin: 0 auto;
    display: flex;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/school/detail.vue